import { render } from "./card-like.vue?vue&type=template&id=6ec1f7b6"
import script from "./card-like.vue?vue&type=script&lang=js"
export * from "./card-like.vue?vue&type=script&lang=js"

import "./card-like.vue?vue&type=style&index=0&id=6ec1f7b6&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__